
          import defu from 'defu'
          import { plugin, defaultConfig, createInput } from '@formkit/vue'
          import { nl, fr, de, en } from '@formkit/i18n'

          // Todo:
          // - map against existing translations available in formkit
          // - check if files exists

          import nlCustom from '~layers/i18n/locales/formkit/nl.ts'
import frCustom from '~layers/i18n/locales/formkit/fr.ts'
import deCustom from '~layers/i18n/locales/formkit/de.ts'
import enCustom from '~layers/i18n/locales/formkit/en.ts'

          import { FormKitPlaceholder, FormKitRating, FormKitToggle } from '#components'

          import formkitConf from '~layers/formkit.config.ts'

          const formkitConfig = formkitConf() || {}

          export default defineNuxtPlugin((nuxtApp) => {

            nuxtApp.vueApp.use(
              plugin,
              defaultConfig(
                defu(formkitConfig, {
                  locale: 'en',
                  locales: {
                    'nl': defu(nlCustom, nl), 'fr': defu(frCustom, fr), 'de': defu(deCustom, de), 'en': defu(enCustom, en)
                  },
                  inputs: {
                    placeholder: createInput(FormKitPlaceholder), rating: createInput(FormKitRating), toggle: createInput(FormKitToggle),
                  },
                })
              )
            )
          })
        